import { HashRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import Projects from './pages/Projects'
import About from './pages/About'
import EnergyProject from './components/EnergyProject'
import SegmentationProject from './components/SegmentationProject'

function App() {
  return (
    <HashRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects/energy" element={<EnergyProject />} />
          <Route path="/projects/segmentation" element={<SegmentationProject />} />
        </Routes>
      </Layout>
    </HashRouter>
  )
}

export default App